import React from "react";
import { Save, Loader2 } from "lucide-react";
import { apiGetPengaturan, apiUpdatePengaturan, formatApiErrorDetail } from "@/lib/api";
import { NOTIF_JENIS } from "@/lib/pushUtil";
import PushPanel from "@/components/PushPanel";

const inputCls = "mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100";
const MODE = [["PUSH", "HP + lonceng"], ["LONCENG", "Lonceng saja"], ["MATI", "Mati"]];

// G1-D: owner notification settings (per event, quiet hours, daily summary).
export default function NotifPanel() {
  const [f, setF] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState(null);

  React.useEffect(() => {
    apiGetPengaturan().then((c) => setF({
      notif_mode: c.notif_mode, notif_jam_tenang: c.notif_jam_tenang,
      notif_jam_ringkasan_lewat: c.notif_jam_ringkasan_lewat, notif_kelebihan_ambang_jam: c.notif_kelebihan_ambang_jam,
    })).catch(() => {});
  }, []);

  const simpan = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    try {
      await apiUpdatePengaturan({ ...f, notif_kelebihan_ambang_jam: Number(f.notif_kelebihan_ambang_jam) });
      setMsg({ ok: true, text: "Pengaturan notifikasi disimpan." });
    } catch (err) {
      setMsg({ ok: false, text: formatApiErrorDetail(err.response?.data?.detail) || err.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="notif-panel" className="rounded-xl border border-slate-800 bg-slate-900/60 p-5 space-y-4">
      <div>
        <h2 className="text-[15px] font-bold text-soq-biru-tua">Notifikasi Owner</h2>
        <p className="text-xs text-slate-500 mt-1">Lonceng di aplikasi dan notifikasi HP (push) hanya untuk Owner. Selama jam tenang, notifikasi HP ditahan lalu dikirim setelah jam tenang; lonceng tetap langsung.</p>
      </div>
      <PushPanel />
      {f && (
        <form onSubmit={simpan} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
            {NOTIF_JENIS.map(([k, label]) => (
              <label key={k} className="flex items-center justify-between gap-3 text-sm text-slate-300">
                <span>{label}</span>
                <select data-testid={`notif-mode-${k}`} value={f.notif_mode[k] || "LONCENG"}
                  onChange={(e) => setF({ ...f, notif_mode: { ...f.notif_mode, [k]: e.target.value } })}
                  className="rounded-lg border border-slate-700 bg-slate-950 px-2 py-1.5 text-xs">
                  {MODE.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </label>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <label className="text-xs text-slate-400 flex items-end gap-2 col-span-2 md:col-span-1">
              <input type="checkbox" data-testid="notif-jam-tenang-aktif" checked={f.notif_jam_tenang.aktif}
                onChange={(e) => setF({ ...f, notif_jam_tenang: { ...f.notif_jam_tenang, aktif: e.target.checked } })} /> Jam tenang aktif
            </label>
            <label className="text-xs text-slate-400">Jam tenang mulai
              <input type="time" data-testid="notif-jam-tenang-mulai" value={f.notif_jam_tenang.mulai} className={inputCls}
                onChange={(e) => setF({ ...f, notif_jam_tenang: { ...f.notif_jam_tenang, mulai: e.target.value } })} /></label>
            <label className="text-xs text-slate-400">sampai
              <input type="time" data-testid="notif-jam-tenang-selesai" value={f.notif_jam_tenang.selesai} className={inputCls}
                onChange={(e) => setF({ ...f, notif_jam_tenang: { ...f.notif_jam_tenang, selesai: e.target.value } })} /></label>
            <label className="text-xs text-slate-400">Ringkasan SPK lewat rencana jam
              <input type="time" data-testid="notif-jam-ringkasan" value={f.notif_jam_ringkasan_lewat} className={inputCls}
                onChange={(e) => setF({ ...f, notif_jam_ringkasan_lewat: e.target.value })} /></label>
            <label className="text-xs text-slate-400">Kelebihan bayar "mendekati batas" bila sisa ≤ (jam)
              <input type="number" min="1" max="47" data-testid="notif-ambang" value={f.notif_kelebihan_ambang_jam} className={inputCls}
                onChange={(e) => setF({ ...f, notif_kelebihan_ambang_jam: e.target.value })} /></label>
          </div>
          <button type="submit" disabled={busy} data-testid="notif-simpan"
            className="inline-flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-50">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Simpan notifikasi
          </button>
          {msg && <p data-testid="notif-msg" className={`text-sm ${msg.ok ? "text-emerald-300" : "text-red-300"}`}>{msg.text}</p>}
        </form>
      )}
    </div>
  );
}
